import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { areAllChildrenLeaf } from '../../../../../utils/treeUtils';
import NodeRow from './NodeRow';
import FinalLevelGrid from './FinalLevelGrid';

const styles = () => ({
  root: {
    width: '100%',
  },

  sectionContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },

  sectionContainerFinalLevel: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },

  sectionContainerFinalLevelWithBackground: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    backgroundColor: '#F8F9FA',
    borderRadius: '4px',
    margin: '2px 0',
    padding: '12px 10px',
  },

  item: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
});

const MARGIN = 10;
const MAX_WIDTH_PERCENT = 100;

/**
 * 階層構造のメニューを表示するコンポーネント
 */
class TreeSectionBase extends React.PureComponent {
  getItemWidth(isLeafNode) {
    const { colCount } = this.props;
    return isLeafNode ? `${MAX_WIDTH_PERCENT / colCount}%` : `${MAX_WIDTH_PERCENT}%`;
  }

  getItemStyle(level, isLeafNode) {
    const width = this.getItemWidth(isLeafNode);
    if (isLeafNode) {
      return {
        width: width,
        flexBasis: width,
        minWidth: 0,
      };
    }

    return {
      width: width,
      marginLeft: `${(level + 1) * MARGIN}px`,
    };
  }

  render() {
    const {
      classes,
      node,
      level,
      selectedItems,
      onToggle,
      colCount,
      contextData,
    } = this.props;

    const hasChildren = node && node.children && node.children.length > 0;

    return (
      <div className={classes.root}>
        {/* 親（このセクションのタイトル） */}
        <NodeRow
          node={node}
          selectedItems={selectedItems}
          onToggle={onToggle}
          isTitle
          contextData={contextData}
        />

        {hasChildren && (() => {
          const allFinal = areAllChildrenLeaf(node.children || []);
          const sectionClassName = allFinal
          ? classes.sectionContainerFinalLevel
          : classes.sectionContainer;
          const sectionStyle = allFinal ? {} : { display: 'block' };

          return (
            <div className={sectionClassName} style={sectionStyle}>
              {allFinal ? (
                // 直下がすべて葉 → グリッドでまとめて表示
                <FinalLevelGrid
                  nodes={node.children}
                  selectedItems={selectedItems}
                  onToggle={onToggle}
                  colCount={colCount}
                  contextData={contextData}
                />
              ) : (
                // 子に階層が混在 → 子ごとに処理
                (node.children || []).map((child, idx) => {
                  if (!child || child.id === undefined || child.id === null) return null;

                  const childHasChildren = !!(child.children && child.children.length > 0);
                  const isFinalLevel = !childHasChildren;
                  const itemStyle = this.getItemStyle(level, isFinalLevel);

                  if (childHasChildren) {
                    // 子に更なる子がある場合は、ここで NodeRow を描かない。
                    // 再帰側(TreeSectionBase)が NodeRow（=タイトル）を描画する。
                    return (
                      <div
                        key={`${level}-${idx}`}
                        style={{ marginLeft: `${MARGIN + (level + 1) * MARGIN}px`, marginTop: '10px' }}
                      >
                        <TreeSectionBase
                          classes={classes}
                          node={child}
                          level={level + 1}
                          selectedItems={selectedItems}
                          onToggle={onToggle}
                          colCount={colCount}
                          contextData={contextData}
                        />
                      </div>
                    );
                  }

                  // ここに来るのは「単体の葉」の場合だけ → この場で1行描く
                  return (
                    <div key={`${level}-${idx}`} style={itemStyle}>
                      <div className={classes.item}>
                        <NodeRow
                          node={child}
                          selectedItems={selectedItems}
                          onToggle={onToggle}
                          contextData={contextData}
                        />
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          );
        })()}
      </div>
    );
  }
}

TreeSectionBase.propTypes = {
  classes: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
  level: PropTypes.number.isRequired,
  selectedItems: PropTypes.object.isRequired, // Immutable Set
  onToggle: PropTypes.func.isRequired,
  colCount: PropTypes.number.isRequired,
  contextData: PropTypes.object,
};

export default withStyles(styles)(TreeSectionBase);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectHierarchicalMenuDialog/common/TreeSection.jsx